module.exports = __webpack_public_path__ + "img/switch-on.8e225a2f.svg";